<section
  class="card-bg relative overflow-hidden rounded-2xl dark:bg-surface-1/60"
  [class.pb-24]="selectedIds().length > 0"
>
  <div class="space-y-6 px-4 py-6 md:px-8 md:py-8">
    <app-unpaid-partner-overview-cards
      [data]="overview()"
      [loading]="loading()"
      [payAllLabel]="payAllButtonLabel"
      [payAllDisabled]="paying() || selectedIds().length > 0"
      [payUrgentDisabled]="true"
      [showUrgentAction]="showUrgentOverviewAction"
      [showAskPrismAi]="false"
      [hideAmount]="true"
      (payAllToBusiness)="payAllToBusiness()"
    >
      <app-unpaid-payments-is-dummy-toggle
        overview-header-actions
        (dummyChange)="onIsDummyToggle($event)"
      ></app-unpaid-payments-is-dummy-toggle>
    </app-unpaid-partner-overview-cards>

    <!-- Filter bar: matches Figma — product filter + search only on first row -->
    <div
      class="relative z-10 rounded-xl border border-[rgba(234,234,234,1)] bg-white p-4 mt-5 shadow-sm dark:border-line dark:bg-surface-1/70 md:p-6"
    >
      <div class="flex flex-col gap-4 md:flex-row md:items-center md:gap-4">
        <!-- <div class="w-full shrink-0 md:w-56 md:max-w-[15rem]">
          <select
            class="h-11 w-full cursor-pointer appearance-none rounded-lg border border-slate-300 bg-white bg-[length:1rem] bg-[right_0.75rem_center] bg-no-repeat px-3.5 pr-10 text-sm text-slate-800 transition
                   focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/25
                   dark:border-line dark:bg-surface-0/90 dark:text-slate-100"
            style="background-image: url('data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 fill=\'none\' stroke=\'%2394a3b8\' stroke-width=%272%27 viewBox=%270 0 24 24%27%3E%3Cpath stroke-linecap=%27round%27 stroke-linejoin=%27round%27 d=%27M19 9l-7 7-7-7%27/%3E%3C/svg%3E')"
            [ngModel]="subStatus()"
            (ngModelChange)="onSubStatusChange($event)"
          >
            <option [ngValue]="-1">All Product Payments</option>
            <option [ngValue]="0">Initiated</option>
            <option [ngValue]="1">Active</option>
            <option [ngValue]="2">Renew</option>
            <option [ngValue]="3">Expired</option>
          </select>
        </div> -->
        <div class="relative min-w-0 flex-1">
          <app-icon-v2
            name="search"
            size="16"
            class="pointer-events-none absolute inset-y-0 left-3.5 my-auto text-slate-400 dark:text-slate-500"
          ></app-icon-v2>
          <input
            class="h-11 w-full rounded-lg border border-slate-300 bg-white py-2 pl-10 pr-3.5 text-sm text-slate-800 placeholder:text-slate-400 transition
                   focus:border-purple-500 focus:outline-none focus:ring-2 focus:ring-purple-500/25
                   dark:border-line dark:bg-surface-0/90 dark:text-slate-100 dark:placeholder:text-slate-500"
            [ngModel]="search()"
            (ngModelChange)="search.set($event)"
            (keyup.enter)="onSearch()"
            placeholder="Search by Name, Email, Microloan Code"
          />
        </div>
        <div class="flex shrink-0 gap-2">
          <button
            type="button"
            class="inline-flex h-11 items-center gap-2 rounded-lg bg-purple-500 px-4 text-sm font-semibold text-white shadow-sm transition hover:bg-purple-600 focus:outline-none focus:ring-2 focus:ring-purple-500/40 dark:bg-purple-500 dark:hover:bg-purple-400"
            (click)="onSearch()"
          >
            Apply
          </button>
          <button
            type="button"
            class="inline-flex h-11 items-center gap-2 rounded-lg border border-slate-300 bg-white px-4 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400/30 dark:border-line dark:bg-surface-2 dark:text-slate-200 dark:hover:bg-line"
            (click)="clearSearch()"
          >
            Clear
          </button>
        </div>
      </div>

      <!-- <details class="group mt-5 border-t border-slate-200 pt-5 dark:border-line">
        <summary
          class="cursor-pointer list-none text-sm font-medium text-slate-600 marker:content-none dark:text-slate-400 [&::-webkit-details-marker]:hidden"
        >
          <span class="inline-flex items-center gap-2">
            Date range
            <svg
              class="h-4 w-4 text-slate-400 transition group-open:rotate-180 dark:text-slate-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </span>
        </summary>
        <div class="mt-4 flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-end">
          <div class="relative z-[28] w-full min-w-0 sm:w-44">
            <label class="mb-2 block text-xs font-medium text-slate-600 dark:text-slate-400">Start date</label>
            <app-selection
              mode="date-picker"
              [enableYearMonthPicker]="true"
              [disableFutureDates]="true"
              minDate="2017-01-01"
              [ngModel]="startDate()"
              (ngModelChange)="onStartDateChange($event)"
              [maxDate]="startDateMax()"
              datePlaceholder="Start date"
            ></app-selection>
          </div>
          <div class="relative z-[27] w-full min-w-0 sm:w-44">
            <label class="mb-2 block text-xs font-medium text-slate-600 dark:text-slate-400">End date</label>
            <app-selection
              mode="date-picker"
              [enableYearMonthPicker]="true"
              [disableFutureDates]="true"
              [ngModel]="endDate()"
              (ngModelChange)="onEndDateChange($event)"
              [minDate]="startDate()"
              [maxDate]="endDateMax()"
              datePlaceholder="End date"
            ></app-selection>
          </div>
          <div class="flex w-full flex-wrap gap-3 sm:ml-auto sm:w-auto">
            <button
              type="button"
              class="inline-flex h-11 flex-1 items-center justify-center rounded-lg bg-purple-500 px-5 text-sm font-semibold text-white shadow-sm transition hover:bg-purple-600 focus:outline-none focus:ring-2 focus:ring-purple-500/40 sm:flex-initial dark:bg-[#a855f7] dark:hover:bg-purple-400"
              (click)="onSearch()"
            >
              Apply
            </button>
            <button
              type="button"
              class="inline-flex h-11 flex-1 items-center justify-center rounded-lg border border-slate-300 bg-white px-5 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-400/30 sm:flex-initial
                     dark:border-line dark:bg-surface-2 dark:text-slate-200 dark:hover:bg-line"
              (click)="resetFilters()"
            >
              Reset
            </button>
          </div>
        </div>
      </details> -->
    </div>

    <div
      class="relative z-0 min-h-[400px] overflow-visible rounded-[14px] border border-[#e5e7eb] bg-white shadow-[0_1px_4px_0_rgba(0,0,0,0.1)] dark:border-surface-3 dark:bg-surface-1"
    >
      <div
        *ngIf="tableBusy()"
        class="absolute inset-0 z-10 flex items-center justify-center overflow-hidden rounded-[14px] bg-white/60 backdrop-blur-sm dark:bg-surface-1/60"
      >
        <div class="flex flex-col items-center gap-4">
          <div class="h-10 w-10 animate-spin rounded-full border-4 border-purple-600 border-t-transparent"></div>
          <p class="animate-pulse font-bold text-slate-600 dark:text-slate-400">{{ tableBusyMessage() }}</p>
        </div>
      </div>

      <div class="p-4" [class.pointer-events-none]="tableBusy()" [class.opacity-50]="tableBusy()">
        <div
          *ngIf="!tableBusy() && !payments().length"
          class="flex min-h-[280px] flex-col items-center justify-center px-4 py-12 text-center"
        >
          <svg width="138" height="81" viewBox="0 0 138 81" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              d="M129.789 70.1323H2.66082C1.95537 70.1315 1.27904 69.8553 0.780215 69.3643C0.281386 68.8733 0.000794248 68.2076 0 67.5132V2.61905C0.000819236 1.92468 0.281418 1.25899 0.780242 0.767996C1.27907 0.277004 1.95538 0.000806374 2.66082 0H129.789C130.494 0.000782547 131.171 0.276972 131.67 0.76797C132.168 1.25897 132.449 1.92467 132.45 2.61905V67.5132C132.449 68.2076 132.168 68.8733 131.67 69.3643C131.171 69.8553 130.494 70.1315 129.789 70.1323ZM2.66082 0.582011C2.11214 0.582616 1.5861 0.797426 1.19812 1.17931C0.810146 1.5612 0.591909 2.07898 0.591294 2.61905V67.5132C0.591934 68.0533 0.810183 68.5711 1.19816 68.9529C1.58613 69.3348 2.11215 69.5496 2.66082 69.5503H129.789C130.338 69.5496 130.864 69.3348 131.252 68.9529C131.64 68.571 131.858 68.0533 131.859 67.5132V2.61905C131.858 2.07899 131.64 1.56123 131.252 1.17934C130.864 0.797463 130.338 0.582641 129.789 0.582011H2.66082Z"
              fill="#EAEAEA"
            />
            <path
              d="M31.4884 31H12.5116C11.8457 30.9992 11.2073 30.717 10.7365 30.2154C10.2656 29.7138 10.0008 29.0337 10 28.3243V11.6757C10.0008 10.9663 10.2656 10.2862 10.7365 9.7846C11.2073 9.28299 11.8457 9.00082 12.5116 9H31.4884C32.1543 9.0008 32.7927 9.28296 33.2635 9.78457C33.7344 10.2862 33.9993 10.9663 34 11.6757V28.3243C33.9993 29.0337 33.7344 29.7138 33.2635 30.2154C32.7927 30.717 32.1543 30.9992 31.4884 31ZM12.5116 9.59459C11.9937 9.59521 11.4972 9.81467 11.1309 10.2048C10.7647 10.595 10.5587 11.1239 10.5581 11.6757V28.3243C10.5587 28.8761 10.7647 29.405 11.1309 29.7952C11.4972 30.1853 11.9937 30.4048 12.5116 30.4054H31.4884C32.0063 30.4048 32.5028 30.1853 32.869 29.7952C33.2353 29.405 33.4413 28.8761 33.4419 28.3243V11.6757C33.4413 11.1239 33.2353 10.595 32.869 10.2048C32.5028 9.81471 32.0063 9.59524 31.4884 9.59459H12.5116Z"
              fill="#EAEAEA"
            />
            <path
              d="M12.0906 37C11.5362 37 11.0044 37.158 10.6123 37.4393C10.2203 37.7206 10 38.1022 10 38.5C10 38.8978 10.2203 39.2794 10.6123 39.5607C11.0044 39.842 11.5362 40 12.0906 40H117.909C118.464 40 118.996 39.842 119.388 39.5607C119.78 39.2794 120 38.8978 120 38.5C120 38.1022 119.78 37.7206 119.388 37.4393C118.996 37.158 118.464 37 117.909 37H12.0906Z"
              fill="#F5F5F5"
            />
            <path
              d="M43.224 14C42.8994 14 42.5881 14.2107 42.3585 14.5858C42.129 14.9609 42 15.4696 42 16C42 16.5304 42.129 17.0391 42.3585 17.4142C42.5881 17.7893 42.8994 18 43.224 18H69.776C70.1006 18 70.4119 17.7893 70.6415 17.4142C70.871 17.0391 71 16.5304 71 16C71 15.4696 70.871 14.9609 70.6415 14.5858C70.4119 14.2107 70.1006 14 69.776 14H43.224Z"
              fill="#EAEAEA"
            />
            <path
              d="M43.4825 22C43.0893 22 42.7122 22.2107 42.4342 22.5858C42.1562 22.9609 42 23.4696 42 24C42 24.5304 42.1562 25.0391 42.4342 25.4142C42.7122 25.7893 43.0893 26 43.4825 26H92.5175C92.9107 26 93.2878 25.7893 93.5658 25.4142C93.8438 25.0391 94 24.5304 94 24C94 23.4696 93.8438 22.9609 93.5658 22.5858C93.2878 22.2107 92.9107 22 92.5175 22H43.4825Z"
              fill="#EAEAEA"
            />
            <path
              d="M11.6155 43C11.187 43 10.7761 43.158 10.4732 43.4393C10.1702 43.7206 10 44.1022 10 44.5C10 44.8978 10.1702 45.2794 10.4732 45.5607C10.7761 45.842 11.187 46 11.6155 46H93.3845C93.813 46 94.2239 45.842 94.5268 45.5607C94.8298 45.2794 95 44.8978 95 44.5C95 44.1022 94.8298 43.7206 94.5268 43.4393C94.2239 43.158 93.813 43 93.3845 43H11.6155Z"
              fill="#F5F5F5"
            />
            <path
              d="M11.2354 49C10.9077 49 10.5935 49.158 10.3618 49.4393C10.1302 49.7206 10 50.1022 10 50.5C10 50.8978 10.1302 51.2794 10.3618 51.5607C10.5935 51.842 10.9077 52 11.2354 52H73.7646C74.0923 52 74.4065 51.842 74.6382 51.5607C74.8698 51.2794 75 50.8978 75 50.5C75 50.1022 74.8698 49.7206 74.6382 49.4393C74.4065 49.158 74.0923 49 73.7646 49H11.2354Z"
              fill="#F5F5F5"
            />
            <path
              d="M10.8553 55C10.6284 55 10.4109 55.158 10.2505 55.4393C10.0901 55.7206 10 56.1022 10 56.5C10 56.8978 10.0901 57.2794 10.2505 57.5607C10.4109 57.842 10.6284 58 10.8553 58H54.1447C54.3716 58 54.5891 57.842 54.7495 57.5607C54.9099 57.2794 55 56.8978 55 56.5C55 56.1022 54.9099 55.7206 54.7495 55.4393C54.5891 55.158 54.3716 55 54.1447 55H10.8553Z"
              fill="#F5F5F5"
            />
            <path
              d="M22 25C24.7614 25 27 22.7614 27 20C27 17.2386 24.7614 15 22 15C19.2386 15 17 17.2386 17 20C17 22.7614 19.2386 25 22 25Z"
              fill="#EAEAEA"
            />
            <path
              d="M110.3 43.9258C116.673 42.7288 122.804 46.9346 123.997 53.3135C124.591 56.491 123.844 59.6074 122.161 62.084L136.68 75.9404C137.724 76.9357 137.777 78.5832 136.802 79.6445C135.757 80.7811 133.97 80.7843 132.922 79.6533H132.921L119.35 64.9941C117.987 65.9865 116.388 66.6992 114.623 67.0303C108.249 68.2274 102.118 64.0217 100.926 57.6426C99.731 51.2611 103.927 45.1229 110.3 43.9258ZM120.618 53.9512C119.775 49.4382 115.439 46.4668 110.935 47.3105C106.43 48.1545 103.462 52.497 104.305 57.0107C105.148 61.5236 109.483 64.4942 113.988 63.6504C118.493 62.8065 121.461 58.4648 120.618 53.9512Z"
              fill="#AD46FF"
              stroke="white"
            />
          </svg>
          <h3 class="mb-2 text-[22px] font-bold text-[#141437] dark:text-white">No Data Found</h3>
          <p class="text-[16px] text-[#7d7d93] dark:text-ink-muted">No matching records found. Please change your search</p>
        </div>

        <div *ngIf="payments().length" class="min-w-0 overflow-x-auto">
          <app-paginated-table
            [headers]="tableHeaders"
            [tableData]="payments()"
            [isCheckboxShow]="true"
            [selection]="selectedRows()"
            [isRowSelectable]="canSelectRowBind"
            (selectionChange)="onSelectionChange($event)"
            [serverSide]="true"
            [totalItems]="totalCount()"
            [pageCount]="totalPages()"
            [currentPage]="page()"
            [pageSize]="pageSize"
            (pageChange)="goToPage($event)"
            tableClass="min-w-max w-full"
            [tableWrapperClass]="'h-full rounded-2xl dark:bg-surface-1 bg-white'"
            containerClass="overflow-x-auto min-w-0"
            [cellTemplates]="{
              serialNo: serialNoTemplate,
              microloanId: microloanIdTemplate,
              contractId: contractIdTemplate,
              platform: platformTemplate,
              status: statusTemplate,
              supporter: supporterTemplate,
              paymentType: paymentTypeTemplate,
              payableAmount: payableAmountTemplate,
              action: actionTemplate
            }"
          ></app-paginated-table>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #serialNoTemplate let-row let-i="index">
  <span class="text-[14px] font-medium tabular-nums text-[#141437] dark:text-white">{{ offset() + i + 1 }}</span>
</ng-template>

<ng-template #supporterTemplate let-row>
  <div class="space-y-1 text-[14px]">
    <div class="flex flex-wrap gap-1">
      <span class="shrink-0 text-[#7d7d93] dark:text-ink-muted">Name:</span>
      <span class="font-medium text-[#141437] dark:text-white">{{ row['investor_name'] || row['investor_id'] || '—' }}</span>
    </div>
    <div class="flex flex-wrap gap-1">
      <span class="shrink-0 text-[#7d7d93] dark:text-ink-muted">Email:</span>
      <span class="break-all text-[#141437] dark:text-white">{{ row['investor_email'] || '—' }}</span>
    </div>
  </div>
</ng-template>

<ng-template #microloanIdTemplate let-row>
  <span class="font-mono text-[14px] font-medium text-[#141437] dark:text-white">{{ getMicroloanDisplayId(row) }}</span>
</ng-template>

<ng-template #platformTemplate let-row>
  <div class="flex items-center gap-3">
    <span
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-[10px] font-bold text-white"
      [ngClass]="{
        'bg-emerald-500': row['partner_id'] == 1,
        'bg-blue-500': row['partner_id'] == 2,
        'bg-violet-500': row['partner_id'] == 3,
        'bg-amber-500': row['partner_id'] == 4,
        'bg-slate-500': !row['partner_id'] || row['partner_id'] > 4
      }"
    >
      {{ (getPartnerLabel(row) || 'L').slice(0, 1) }}
    </span>
    <span class="text-[14px] font-medium text-[#141437] dark:text-white">{{ getPartnerLabel(row) || 'Lendee' }}</span>
  </div>
</ng-template>

<ng-template #contractIdTemplate let-row>
  <span class="text-[14px] font-medium tabular-nums text-[#141437] dark:text-white">
    <ng-container *ngIf="row['contract_id'] != null; else noContractCell">{{ row['contract_id'] }}</ng-container>
    <ng-template #noContractCell>—</ng-template>
  </span>
</ng-template>

<ng-template #paymentTypeTemplate let-row>
  <span class="text-[14px] text-[#141437] dark:text-white">{{ getPaymentInfoSublabel(row) }}</span>
</ng-template>

<ng-template #payableAmountTemplate let-row>
  <span class="text-[14px] font-semibold tabular-nums text-[#141437] dark:text-white">
    {{ getAmount(row) | currency }}
  </span>
</ng-template>

<ng-template #statusTemplate let-row>
  <span
    *ngIf="getPaymentStatusLabel(row)"
    class="inline-flex rounded-full px-2.5 py-1 text-xs font-semibold"
    [ngClass]="{
      'bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-300': getPaymentStatusLabel(row) === 'Un-released',
      'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300': getPaymentStatusLabel(row) === 'Released',
      'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400':
        getPaymentStatusLabel(row) !== 'Un-released' && getPaymentStatusLabel(row) !== 'Released'
    }"
  >
    {{ getPaymentStatusLabel(row) }}
  </span>
</ng-template>

<ng-template #actionTemplate let-row>
  <div class="flex items-center justify-start">
    <button
      *ngIf="canPayRow(row)"
      type="button"
      class="inline-flex h-8 items-center justify-center rounded-[8px] bg-[#AD46FF] px-4 text-[13px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
      [disabled]="paying() || selectedIds().length > 0"
      (click)="paySingle(row)"
    >
      Pay
    </button>
  </div>
</ng-template>

<div
  class="bulk-selection-footer fixed bottom-0 right-0 z-[100] border-t border-[#e5e7eb] bg-white p-4 shadow-[0_-4px_10px_0_rgba(0,0,0,0.05)] transition-[transform,opacity] duration-300 ease-out will-change-transform dark:border-surface-3 dark:bg-surface-1"
  [class.bulk-selection-footer--visible]="selectedIds().length > 0"
  [attr.aria-hidden]="selectedIds().length === 0"
  [style.left]="'var(--sidebar-width, 0px)'"
>
  <div class="mx-auto flex flex-col items-start gap-4 px-4 xl:flex-row xl:items-center xl:justify-between xl:px-8">
    <div class="flex flex-col">
      <div class="text-[24px] font-bold leading-tight text-[#141437] tabular-nums dark:text-white">
        {{ totalSelectedAmount() | currency }}
      </div>
      <div class="mt-1 flex flex-wrap items-center gap-4 text-[13px] text-[#7d7d93] dark:text-ink-muted">
        <div class="flex items-center gap-1.5">
          <app-icon-v2 name="building" size="14"></app-icon-v2>
          Paying to
          <span class="font-semibold text-[#141437] dark:text-white">{{ selectedBusinessesCount() }}</span>
          businesses
        </div>
        <span class="text-[#e5e7eb] dark:text-surface-3">|</span>
        <div class="flex items-center gap-1.5">
          <app-icon-v2 name="receipt" size="14"></app-icon-v2>
          <span class="font-semibold text-[#141437] dark:text-white">{{ selectedPayableCount() }}</span>
          Payments
        </div>
      </div>
    </div>

    <div class="flex items-center gap-3">
      <button
        type="button"
        class="inline-flex h-11 items-center rounded-[10px] bg-[#AD46FF] px-6 text-[14px] font-medium text-white transition hover:bg-[#962ef7] disabled:cursor-not-allowed disabled:opacity-60"
        [disabled]="paying() || !selectedPayableCount()"
        (click)="paySelected()"
      >
        {{ paying() ? 'Processing...' : 'Make Payments' }}
      </button>
    </div>
  </div>
</div>
